(function() {
  'use strict';

  angular.module('blocks.widgets', [
    'widgets.forms',
    'widgets.dashboard',
    'widgets.files'
  ]);
})();
